import React, { useState,useEffect } from 'react';
import { NavLink,useLocation} from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Container,Placeholder,Navbar,Nav,Offcanvas,Button,Form,InputGroup,Image } from 'react-bootstrap';
import MainMenuItems from './MainMenuItems';
export default function MainMenu() 
{
    const { t } = useTranslation();
    const location = useLocation();
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[scrolled, setScrolled] = useState(false);
    const[isLoading, setLoading] = useState(true);
    const[mainMenu,setMenus]=useState([]);
    const[query, setQuery] = useState('');
    const [offcanvasVisible, setOffcanvasVisible] = useState(false);
    const handleSearch = async (e) => 
    {
        e.preventDefault();
        if(query)
        {
            window.open('https://www.google.com/search?q=site:igdtuw.ac.in '+query, '_blank');
        }        
    };
    useEffect(()=>
    {
        const allMainMenu = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL + "menu/mainMenu");
                if (response.ok) 
                {
                    const mainMenu = await response.json();
                    for (const menuItem of mainMenu) 
                    {
                        //console.log(menuItem);
                        // if( menuItem.sp_id === 7 || menuItem.sp_id === 8 )
                        // {
                            
                        // } 
                        await fetchSubMenuRecursive(menuItem);                      
                    }
                    setMenus(mainMenu);                    
                    if (global.config.IsPrint === true) 
                    {
                        console.info('Main Menu : Result', mainMenu);
                    }
                }
            } 
            catch (error) 
            {
                console.error('Main Menu : Error', error.message);
            }
            finally
            {
                setLoading(false);
            }
        };
        const fetchSubMenuRecursive = async (menuItem) => 
        {
            const response = await fetch(global.config.API_URL + "menu/mainSubMenu/" + menuItem.sp_id);
            if (response.ok) 
            {
                const subMenus = await response.json();
                if (subMenus.length > 0) 
                {
                    menuItem.submenu = subMenus;
                    // Recursively fetch submenus for each submenu item
                    // for (const subMenuItem of subMenus) 
                    // {
                    //     await fetchSubMenuRecursive(subMenuItem);
                    // }
                }
            }
        };
        allMainMenu();
        const handleScroll = () => 
        {
            const offset = window.scrollY;
            if (offset > 20) {
              setScrolled(true);
            } else {
              setScrolled(false);
            }
        };      
        window.addEventListener('scroll', handleScroll);      
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    },[])
    useEffect(() => {
        // Close Offcanvas on location change
        setOffcanvasVisible(false);
    }, [location]);
    const toggleOffcanvas = () => {
        setOffcanvasVisible(!offcanvasVisible);
    };
    return (
        <Navbar bg="success" fixed={scrolled ? 'top' : ''} className="main-navbar p-0" key="lg" expand="lg" id="MainNavbar">
            <Container>
                <NavLink to="/" onClick={() => setOffcanvasVisible(false)} aria-label={appLanguage === 'hi' ? 'स्टिकी लोगो से होम पेज पर जाएं' : 'From the small logo go to home page'} className='navbar-brand'>
                    <Image src={global.config.uploadPath+'2041938450.png'} alt={t('SiteName')} loading="lazy" fluid width={46} height={46} />
                </NavLink>
                <Navbar.Toggle className='float-end' aria-controls="mainNav" onClick={toggleOffcanvas} />
                <Navbar.Offcanvas id='mainNav' aria-labelledby="mainNavLabel" placement="start" show={offcanvasVisible} onHide={() => setOffcanvasVisible(false)}>
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id="mainNavLabel">{t('MainMenu')}</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body className='bg-success position-relative'>
                    {isLoading ? (
                        <Nav className="justify-content-start flex-grow-1">
                            {[...Array(10)].map((_,index)=>(
                                <Nav.Link key={index} style={{width:"100px"}} data-aos="flip-up" data-aos-duration="1500"><Placeholder xs={12} /></Nav.Link>
                            ))}
                        </Nav>
                        ) : (
                        <React.Fragment>
                        <Nav className="justify-content-start flex-grow-1">
                            <Nav.Item className='border-0'>
                                <NavLink to="/"  onClick={() => setOffcanvasVisible(false)} className={({ isActive }) => (isActive ? 'active nav-link' : 'nav-link')} aria-label={appLanguage === 'hi' ? 'होम आइकन से होम पेज पर जाएं' : 'From the home icon go to home page'} data-aos="flip-up" data-aos-duration="1500">
                                    {appLanguage === 'hi' ? 'होम' : 'Home'}
                                </NavLink>
                            </Nav.Item>
                            {mainMenu.map((menu,index) => {
                                return <MainMenuItems menu={menu} key={index} />;
                            })}                            
                        </Nav>
                        <form className='search-form form-inline py-1' onSubmit={handleSearch}>
                            <InputGroup className='rounded-pill'>
                                <Form.Control className='bg-light border-0' value={query} onChange={(e) => setQuery(e.target.value)} placeholder={t('SearchPlace')} aria-label={t('Search')} required />
                                <Button variant="light" type='submit'>
                                    <i className="bi bi-search"></i>
                                    <span className="visually-hidden">{t('Search')}</span>
                                </Button>
                            </InputGroup>
                        </form>
                        </React.Fragment>
                    )}                        
                    </Offcanvas.Body>    
                </Navbar.Offcanvas>
            </Container>
        </Navbar>
    );
  }